class OnSaleReportStatus {
    url;
    period;
    propertyId;
    constructor(data) {
        this.url = data.url;
        this.period = data.period;
        this.propertyId = data.propertyId;
    }
}
export default OnSaleReportStatus;
